import { ItProviderDetails } from '@ffd/api-client';

// IT-provider contact fields captured on the IT-provider-details step, carried in memory to the
// install-options step so both are sent together in a single saveItProviderInfo call.
export interface ItProviderDraft {
  itProviderName?: string;
  itPrimaryContactFirstName?: string;
  itPrimaryContactLastName?: string;
  itPrimaryContactEmail?: string;
  itPrimaryContactPhoneNumber?: string;
}

// The API contract carries the provider as an all-or-nothing object: present and complete when the
// practice has an IT provider, omitted otherwise. Return the details only when every field is filled.
export function toItProviderDetails(draft?: ItProviderDraft): ItProviderDetails | undefined {
  if (!draft) {
    return undefined;
  }

  const { itProviderName, itPrimaryContactFirstName, itPrimaryContactLastName, itPrimaryContactEmail, itPrimaryContactPhoneNumber } = draft;

  if (
    !itProviderName ||
    !itPrimaryContactFirstName ||
    !itPrimaryContactLastName ||
    !itPrimaryContactEmail ||
    !itPrimaryContactPhoneNumber
  ) {
    return undefined;
  }

  return { itProviderName, itPrimaryContactFirstName, itPrimaryContactLastName, itPrimaryContactEmail, itPrimaryContactPhoneNumber };
}
